//  Fired on the window when a SAMS token could not be refreshed and the session
//  is genuinely dead. SessionTimeout listens for this so the user gets a warning
//  modal instead of being redirected out of the app with unsaved work.
export const SESSION_EXPIRED_EVENT = 'ed3n:session-expired';

const SessionConstants = {

    SAMS_ACCESS_TOKEN: 'samsToken',
    SAMS_REFRESH_TOKEN: 'samsRefreshToken',
    SAMS_TOKEN_EXPIRES_AT: 'samsTokenExpiresAt',
    USER_EMAIL: 'useremail',
    USER_FIRSTNAME: 'firstname',
    USER_LASTNAME: 'lastName',
    PROGRAM_ID: 'programId',
    NBS_PROGRAM: 'nbsprograms',
    IS_MANAGER: 'isManager',
    IS_SYSADMIN: 'isSysAdmin',
    IS_IMPERSONATING: 'isImpersonating',
    CURRENT_USER: 'currentUser',
    ERROR_MESSAGE: 'errorMessage',
    ERROR_DESCRIPTION: 'errorDescription',
    TIMEOUT_STATUS: 'timeoutStatus',
    LOGOUT_STATUS: 'logoutStatus',
    //  DEPRECATED / no longer read. Formerly set when a navigation-time SAMS refresh was
    //  rejected, to make SessionTimeout show a "session ended" countdown on mount. Grace
    //  periods were removed - an unrenewable session now logs out immediately - so nothing
    //  writes or reads this anymore. Kept only so clearAllSessionVariables can defensively
    //  remove any value left behind in a restored/older session; safe to delete later.
    SESSION_ENDED: 'sessionEnded',
    //  Absolute wall-clock time (ms since epoch) at which the session must end regardless of
    //  activity. Set once at login and never extended, so continual navigation cannot keep a
    //  session alive forever, and a machine powered off past this time is logged out on return.
    SESSION_HARD_EXPIRY: 'sessionHardExpiry',
    //  Track which absolute-cap pre-warnings have already been shown, storing the
    //  SESSION_HARD_EXPIRY value they were shown for. Because that value is unique per login, a
    //  new session's cap never matches a stale flag, so the 30-minute and 5-minute notices
    //  re-arm automatically at the next login without anything having to clear them.
    HARDCAP_WARN_30_FOR: 'hardCapWarn30For',
    HARDCAP_WARN_5_FOR: 'hardCapWarn5For',
    FULLSCREEN: 'fullscreen',
    DEVLOGIN: 'devLogin',
    DEVLOGIN_USERNAME: 'devLoginUsername',
    DEVLOGIN_PASSWORD: 'devLoginPassword',
    ORIGINAL_USER_EMAIL: 'originalUserEmail',
    ORIGINAL_USER_FIRSTNAME: 'originalUserFirstName',
    ORIGINAL_USER_LASTNAME: 'originalUserLastName',
    ORIGINAL_CURRENT_USER: 'originalCurrentUser',
    ORIGINAL_PROGRAM_ID: 'originalProgramId',
    ORIGINAL_PROGRAM_NAME: 'originalProgramName',
    ORIGINAL_IS_MANAGER: 'originalIsManager',
    ORIGINAL_IS_SYSADMIN: 'originalIsSysAdmin',
    BIOCHEMICAL_ALERT_SHOWN: 'biochemicalAlertShown'
};

export default SessionConstants;